export { TAB } from '../internal/shared/constants/assetPreview';
export function getCustomTabId(tabKey) {
  return `custom-tab-${tabKey}`;
}